// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");

var dot = require("./lib/dot");
var playlistTemplate = dot.compile(require("./_playlist.html"));
var videoContainer = document.querySelector(".video-container");
var playlistContainer = document.querySelector(".playlist-container");
var replayTeaser = document.querySelectorAll(".replayTeaser");
var looper = document.querySelector("#looper");
var playButton = document.querySelector(".brightcove__button");
var teaserVidCon = document.querySelector("#secondVid");

// var teaserVidCon = document.querySelector("#secondVid");
var link = document.getElementById("story-link");

var log = console.log.bind(console);



var playlistID = '8XMOly72';

var qsa = s => Array.prototype.slice.call(document.querySelectorAll(s));

var closest = function(element, className) {
  while (element && !element.classList.contains(className)) element = element.parentElement;
  return element;
};

var title = document.getElementById("title");
var titleHed = document.getElementById("title-hed");



// overviewVid = jwplayer('teaser').setup({
// playlist: `https://cdn.jwplayer.com/v2/media/hUnsbabo`
// })

window.onload = function(){


    replayTeaser.forEach(el => el.addEventListener('click', () => {
      // console.log(player);
      // var playingAd = player.ads.state == "ad-playback";
      // if (!playingAd) {
          // jwplayer().pause();
          if (playerInstance){
            playerInstance.pause();
          }

          teaserVidCon.classList.remove("hide");
          looper.classList.add("hide");
          playButton.classList.add("hide");

          // window.scrollTo(0, 0);
          window.location = "#player";

          link.setAttribute("href", "https://www.seattletimes.com/video/");
          title.innerHTML = "During the transportation of Japanese Americans to the Minidoka incarceration camp, a news photographer told Mitsuye Yamada and her family to smile for a photograph. The photograph ran on The Seattle Times' front page on August 14, 1942, and compelled Yamada to write her poem 'Evacuation' while in camp. (Corinne Chin and Ramon Dompor / The Seattle Times)";
          titleHed.innerHTML = "The legacy of a photograph";
          // jwplayer('botr_hUnsbabo_UXknQA8J_div').currentTime(0);
          jwplayer('botr_F8KAs6W3_6FiOi49A_div').seek(0);
          jwplayer('botr_F8KAs6W3_6FiOi49A_div').play();
          // overviewVid.seek(0);
          // overviewVid.play();
      // } else {}
    }));


var getThumbnails = function({ playlist }) {
  console.log(playlist);
  playlistContainer.innerHTML = playlistTemplate(playlist);

  setClickEvent(playlist);

}

var playerInstance;

// On click, destroy existing player, setup new player in target div
var handleActivePlayer = function(thisPlaylist, number) {

  var heynow = thisPlaylist[number];
  



        document.querySelector("#title-link").style.visibility = (heynow.link_url === "") ? "hidden" : "visible";

        link.setAttribute("href", heynow.link_url);
        title.innerHTML = heynow.description;
        titleHed.innerHTML = heynow.title;

  // if (playerInstance) {
  //   playerInstance.remove();
  // }
  // thumbs.forEach(t => t.classList.remove('active'));
  // target.classList.add('active');
  //
  // Chain .play() onto player setup (rather than autostart: true)
  playerInstance = jwplayer('firstVid').setup({
  playlist: `https://cdn.jwplayer.com/v2/media/${heynow.mediaid}`,
  "mute": false,
  }).play();

console.log(number + " " + thisPlaylist.length);



  // // Destroy the player and replace with thumbnail
  playerInstance.on('complete', () => {
    if (number === (thisPlaylist.length - 1)){
      handleActivePlayer(thisPlaylist, 0);
    } else {
      handleActivePlayer(thisPlaylist, (number + 1));
    }

    // playerInstance.remove();
    // playerInstance = null;
  });
};


fetch(`https://cdn.jwplayer.com/v2/playlists/${playlistID}`).then(r => r.json()).then(getThumbnails);

var setClickEvent = function(chosenPlaylist) {

document.querySelectorAll('.playlist-item').forEach(el => el.addEventListener('click', () => {
  jwplayer('botr_F8KAs6W3_6FiOi49A_div').pause();
  window.location = "#player";
  var mediaID = el.getAttribute('data-id');
  teaserVidCon.classList.add("hide");
  looper.classList.add("hide");
  playButton.classList.add("hide");

  for (let i = 0; i < chosenPlaylist.length; i++) {
    var each = chosenPlaylist[i];
    if (each.mediaid === mediaID){
      handleActivePlayer(chosenPlaylist, i);
    } else {};
  };

}));
};
}
